// eslint-disable-next-line import/prefer-default-export
export const beachClubBookingsFields = [
  { key: 'folio', label: 'Confirmación' },
  { key: 'housingnumber', label: 'Vivienda / Propietario' },
  { key: 'visitDate', label: 'Visita' },
  { key: 'people', label: 'Personas' },
  { key: 'total', label: 'Total en la entrada' },
  { key: 'statusname', label: 'Estatus' },
  { key: 'createDate', label: 'Solicitada el' },
]
